import { defineFcm } from '../shared/factory';

export const FCM_DMI_ENABLED = defineFcm('dmi_enabled').asBoolean().withDefault(false).toConfig({
	owner: 'squad-scaled-outreach',
	scope: 'petition-service',
	context: 'DMI kill switch',
	description:
		'Kill switch for DMI (petition_service), gating whether the async candidate-pool consumer and the on-platform decision-maker assignment path run LLM-based petition classification.',
});
